import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormDynamicTextField, FormDynamicTextFieldInput, FormFields } from "sprint-common-web";

import { useEditBuzzIdsForm } from "./useEditBuzzIdsForm";

export interface EditBuzzIdsFormProps {
    systemId: string;
    onCancel(): void;
    onSubmit(): void;
}

export interface EditBuzzIdsFormInputs {
    buzzIds: FormDynamicTextFieldInput[];
}

export const EditBuzzIdsForm: React.VFC<EditBuzzIdsFormProps> = ({
    systemId,
    onSubmit,
    onCancel
}: EditBuzzIdsFormProps) => {
    const { itemToEdit, editBuzzIds } = useEditBuzzIdsForm(systemId);

    const { errors, control, formState, handleSubmit } = useForm<EditBuzzIdsFormInputs>({
        defaultValues: {
            buzzIds: itemToEdit.map((buzzId) => ({ value: buzzId }))
        },
        criteriaMode: "all"
    });

    const handleEditBuzzIds = async (inputs: EditBuzzIdsFormInputs) => {
        await editBuzzIds(inputs);
        onSubmit();
    };

    const handleCancelButtonClick = () => {
        onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleEditBuzzIds)}>
            <FormFields>
                <FormDynamicTextField control={control} errors={errors} label="Buzz Id" name="buzzIds" />
            </FormFields>
            <FormActions
                isLoading={formState.isValidating || formState.isSubmitting}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
